module.exports = "https://web-phone.apps.phone.com/static/media/header-background.3e638194.png";